// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { getUsers, deleteUser } from "../../services/userService";
// import { toast } from "react-toastify";
// import {
//   FaPlus,
//   FaEdit,
//   FaTrash,
//   FaChevronLeft,
//   FaChevronRight,
//   FaSearch,
// } from "react-icons/fa";
// import "./UserListLayer.css";

// /* =========================
//    ROLE LABEL MAP ✅
// ========================= */
// const ROLE_LABELS = {
//   user: "User",
//   tm: "Team Manager",
//   sales: "Sales Executive",
// };

// const UserListLayer = () => {
//   const navigate = useNavigate();

//   const [users, setUsers] = useState([]);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [pageSize, setPageSize] = useState(10);
//   const [page, setPage] = useState(1);

//   useEffect(() => {
//     loadUsers();
//   }, []);

//   const loadUsers = async () => {
//     const res = await getUsers();
//     if (res.status === "success") {
//       setUsers(res.data || []);
//     }
//   };

//   /* =========================
//      SEARCH + STATUS FILTER
//   ========================= */
//   const filteredUsers = users.filter((u) => {
//     const matchesSearch =
//       `${u.name} ${u.email} ${u.mobile}`
//         .toLowerCase()
//         .includes(search.toLowerCase());

//     const matchesStatus =
//       statusFilter === "all" || u.status === statusFilter;

//     return matchesSearch && matchesStatus;
//   });

//   /* =========================
//      PAGINATION
//   ========================= */
//   const totalPages =
//     pageSize === "all"
//       ? 1
//       : Math.ceil(filteredUsers.length / pageSize);

//   const displayedUsers =
//     pageSize === "all"
//       ? filteredUsers
//       : filteredUsers.slice(
//           (page - 1) * pageSize,
//           page * pageSize
//         );

//   const getRowIndex = (i) => {
//     if (pageSize === "all") return i + 1;
//     return (page - 1) * pageSize + i + 1;
//   };

//   /* =========================
//      DELETE
//   ========================= */
//   const handleDelete = async (user_id) => {
//     if (!window.confirm("Delete user?")) return;

//     const res = await deleteUser(user_id);
//     if (res.status === "success") {
//       toast.success("User deleted");
//       loadUsers();
//     } else {
//       toast.error("Delete failed");
//     }
//   };

//   return (
//     <div className="user-list-wrapper">
//       <div className="user-list-card">

//         {/* HEADER */}
//         <div className="list-header">
//           <h5>User Management</h5>
//           <button
//             className="btn-primary"
//             onClick={() => navigate("/add-user")}
//           >
//             <FaPlus /> Add User
//           </button>
//         </div>

//         {/* CONTROLS */}
//         <div className="list-controls">

//           {/* SEARCH */}
//           <div className="search-box">
//             <FaSearch />
//             <input
//               type="text"
//               placeholder="Search by name, email or mobile"
//               value={search}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//             />
//           </div>

//           {/* STATUS FILTER */}
//           <div className="status-filter">
//             <select
//               value={statusFilter}
//               onChange={(e) => {
//                 setStatusFilter(e.target.value);
//                 setPage(1);
//               }}
//             >
//               <option value="all">All Status</option>
//               <option value="active">Active</option>
//               <option value="inactive">Inactive</option>
//             </select>
//           </div>

//           {/* PAGE SIZE */}
//           <div className="page-size">
//             <label>Show</label>
//             <select
//               value={pageSize}
//               onChange={(e) => {
//                 setPageSize(
//                   e.target.value === "all"
//                     ? "all"
//                     : Number(e.target.value)
//                 );
//                 setPage(1);
//               }}
//             >
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//               <option value={50}>50</option>
//               <option value="all">All</option>
//             </select>
//             <span>entries</span>
//           </div>

//         </div>

//         {/* TABLE */}
//         <div className="table-responsive">
//           <table className="user-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Mobile</th>
//                 <th>Role</th>
//                 <th>Status</th>
//                 <th className="text-center">Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {displayedUsers.length === 0 ? (
//                 <tr>
//                   <td colSpan="7" className="no-data">
//                     No users found
//                   </td>
//                 </tr>
//               ) : (
//                 displayedUsers.map((u, i) => (
//                   <tr key={u.id}>
//                     <td>{getRowIndex(i)}</td>
//                     <td>{u.name}</td>
//                     <td>{u.email}</td>
//                     <td>{u.mobile}</td>

//                     {/* ✅ ROLE TEXT FIXED */}
//                     <td>{ROLE_LABELS[u.role] || u.role}</td>

//                     <td>
//                       <span className={`status-badge ${u.status}`}>
//                         {u.status}
//                       </span>
//                     </td>

//                     <td className="actions">
//                       <button onClick={() => navigate(`/add-user/${u.id}`)}>
//                         <FaEdit />
//                       </button>
//                       <button onClick={() => handleDelete(u.id)}>
//                         <FaTrash />
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* PAGINATION */}
//         {pageSize !== "all" && totalPages > 1 && (
//           <div className="pagination">
//             <button disabled={page === 1} onClick={() => setPage(page - 1)}>
//               <FaChevronLeft />
//             </button>
//             <span>
//               Page {page} of {totalPages}
//             </span>
//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(page + 1)}
//             >
//               <FaChevronRight />
//             </button>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default UserListLayer;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUsers, deleteUser, deleteMultipleUsers } from "../../services/userService";
import { toast } from "react-toastify";
import {
  FaPlus, FaEdit, FaTrash, FaChevronLeft, FaChevronRight, FaSearch, FaCopy
} from "react-icons/fa";
import "./UserListLayer.css";

const ROLE_LABELS = {
  user: "User",
  tm: "Team Manager",
  sales: "Sales Executive",
  operator: "Operator",
};

const UserListLayer = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const res = await getUsers();
      // Safety check to prevent "cannot destructure" errors
      if (res && res.status === "success" && res.data) {
        setUsers(res.data);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setUsers([]);
    }
  };

  // Logic to copy both Email and Password at once
  const handleCopyCredentials = (email, password) => {
    const textToCopy = `Email: ${email} | Password: ${password}`;
    navigator.clipboard.writeText(textToCopy);
    toast.success("Credentials copied successfully!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const filteredUsers = users.filter((u) => {
    const matchesSearch = `${u.name} ${u.email} ${u.mobile}`.toLowerCase().includes(search.toLowerCase());
    const matchesStatus = statusFilter === "all" || u.status?.toLowerCase() === statusFilter.toLowerCase();
    return matchesSearch && matchesStatus;
  });

  const totalPages = pageSize === "all" ? 1 : Math.ceil(filteredUsers.length / pageSize);
  const displayedUsers = pageSize === "all" ? filteredUsers : filteredUsers.slice((page - 1) * pageSize, page * pageSize);

  const handleSelectUser = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === displayedUsers.length && displayedUsers.length > 0) {
      setSelectedIds([]);
    } else {
      setSelectedIds(displayedUsers.map(u => u.id));
    }
  };

  const handleDelete = async (user_id) => {
    if (!window.confirm("Delete user?")) return;
    const res = await deleteUser(user_id);
    if (res.status === "success") {
      toast.success("User deleted");
      loadUsers();
    }
  };

  const handleBulkDelete = async () => {
    if (selectedIds.length === 0) return;
    if (!window.confirm(`Delete ${selectedIds.length} selected users?`)) return;

    const res = await deleteMultipleUsers(selectedIds);
    if (res.status === "success") {
      toast.success(`${selectedIds.length} users deleted`);
      setSelectedIds([]);
      loadUsers();
    }
  };

  return (
    <div className="user-list-wrapper">
      <div className="user-list-card">
        <div className="list-header">
          <h5>User Management</h5>
          <div className="header-actions">
            {selectedIds.length > 0 && (
              <button className="btn-bulk-delete" onClick={handleBulkDelete}>
                <FaTrash /> Delete ({selectedIds.length})
              </button>
            )}
            <button className="btn-primary" onClick={() => navigate("/add-user")}>
              <FaPlus /> Add User
            </button>
          </div>
        </div>

        <div className="list-controls">
          <div className="search-box">
            <FaSearch />
            <input
              type="text"
              placeholder="Search users..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </div>

          <div className="list-controls-right">
            <select className="status-select" value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            <div className="page-size">
              <select value={pageSize} onChange={(e) => { setPageSize(e.target.value === "all" ? "all" : Number(e.target.value)); setPage(1); }}>
                <option value={10}>10 Rows</option>
                <option value={25}>25 Rows</option>
                <option value="all">Show All</option>
              </select>
            </div>
          </div>
        </div>

        <div className="table-container">
          <table className="user-table">
            <thead>
              <tr>
                <th>
                  <input 
                    type="checkbox" 
                    onChange={handleSelectAll} 
                    checked={displayedUsers.length > 0 && selectedIds.length === displayedUsers.length}
                  />
                </th>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Password</th>
                <th>Role</th>
                <th>Status</th>
                <th>Quick Copy</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayedUsers.map((u, i) => (
                <tr key={u.id} className={selectedIds.includes(u.id) ? "selected-row" : ""}>
                  <td>
                    <input 
                      type="checkbox" 
                      checked={selectedIds.includes(u.id)} 
                      onChange={() => handleSelectUser(u.id)} 
                    />
                  </td>
                  <td>{ pageSize === "all" ? i + 1 : (page - 1) * pageSize + i + 1 }</td>
                  <td className="user-name-cell"><strong>{u.name}</strong></td>
                  <td>{u.email}</td>
                  <td className="password-cell"><code>{u.password}</code></td>
                  <td>{ROLE_LABELS[u.role] || u.role}</td>
                  <td>
                    <span className={`status-badge ${u.status?.toLowerCase()}`}>{u.status}</span>
                  </td>
                  {/* SINGLE COPY BUTTON FOR BOTH */}
                  <td>
                    <button 
                      className="btn-copy-all" 
                      title="Copy Email & Password"
                      onClick={() => handleCopyCredentials(u.email, u.password)}
                    >
                      <FaCopy /> Copy
                    </button>
                  </td>
                  <td className="actions">
                    <button className="btn-edit" onClick={() => navigate(`/add-user/${u.id}`)}><FaEdit /></button>
                    <button className="btn-delete" onClick={() => handleDelete(u.id)}><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {pageSize !== "all" && totalPages > 1 && (
          <div className="pagination">
            <button disabled={page === 1} onClick={() => setPage(page - 1)}><FaChevronLeft /></button>
            <span className="page-info">{page} / {totalPages}</span>
            <button disabled={page === totalPages} onClick={() => setPage(page + 1)}><FaChevronRight /></button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserListLayer;